import { adminHttp } from './adminRequest'

export const adminApi = {
  login: (data) => adminHttp.post('/login', data),
  dashboard: (params) => adminHttp.get('/dashboard', { params }),
  orders: (params) => adminHttp.get('/orders', { params }),
  withdrawalsSummary: () => adminHttp.get('/withdrawals/summary'),
  withdrawals: (params) => adminHttp.get('/withdrawals', { params }),
  withdrawalAudit: (id, data) => adminHttp.post(`/withdrawals/${id}/audit`, data),
  merchantsSummary: () => adminHttp.get('/merchants/summary'),
  merchants: (params) => adminHttp.get('/merchants', { params }),
  merchantDetail: (id) => adminHttp.get(`/merchants/${id}`),
  merchantCreate: (data) => adminHttp.post('/merchants', data),
  merchantUpdate: (id, data) => adminHttp.put(`/merchants/${id}`, data),
  /** 提现手续费配置（按币种 + 链） */
  withdrawFeeConfigs: () => adminHttp.get('/withdraw-fee-configs'),
  withdrawFeeSave: (data) => adminHttp.post('/withdraw-fee-configs', data),
  withdrawFeeDelete: (id) => adminHttp.delete(`/withdraw-fee-configs/${id}`)
}
